module.exports = __webpack_public_path__ + "assets/AntiMiteVHITemplate-50e6f08bb59bbb838d2bb015aa3ccb99.xlsx";